import {
  ReservationLocation,
  Unit,
} from '@wix/ambassador-table-reservations-v1-reservation-location/types'

import {defaultBusinessSchedule} from '../../utils/businessSchedule'

export const EDITOR_MOCK_RESERVATION_LOCATION_ID = 'editor-mock-reservation-location-id'

export const reservationLocationMock: ReservationLocation = {
  id: EDITOR_MOCK_RESERVATION_LOCATION_ID,
  location: {
    id: 'id',
    name: 'San Francisco',
    timeZone: 'America/Los_Angeles',
    address: {
      country: 'US',
      subdivision: 'CA',
      city: 'San Francisco',
      formattedAddress: 'San Francisco, CA, USA',
      geocode: {
        latitude: 37.7749295,
        longitude: -122.4194155,
      },
    },
  },
  configuration: {
    onlineReservations: {
      partySize: {
        min: 1,
        max: 6,
      },
      minimumReservationNotice: {
        number: 30,
        unit: Unit.MINUTES,
      },
      turnoverTimeRules: [],
      onlineReservationsEnabled: true,
      businessSchedule: defaultBusinessSchedule,
    },
  },
}
